import { CombosService } from 'src/app/services/combos.service';
import { RepositoryService } from 'src/app/services/repository.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FichaCadastro } from 'src/app/models/ficha-cadastro';
import { Criptografar } from 'src/app/util/criptografar';
import { SelectList } from 'src/app/models/selectlist';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
import { AcompanhamentoService } from 'src/app/services/acompanhamento.service';
import { FileSaverService } from 'ngx-filesaver';
import { Acesso } from 'src/app/models/acesso';
import { ConfirmacaoInscricaoService } from 'src/app/services/confirmacao-inscricao.service';

@Component({
  selector: 'app-confirmacaoinscricao',
  templateUrl: './confirmacaoinscricao.component.html',
  styleUrls: ['./confirmacaoinscricao.component.css']
})
export class ConfirmacaoinscricaoComponent implements OnInit {

  confirmarFichaInscricaoForm!: FormGroup;
  public confirmacaoFichaInscricao: FichaCadastro;
  ind_prazpConcurso: string = '';
  isExibeOpcaoCotista: boolean = true;
  listaRadioCotista!: SelectList[];
  listaComboCienciaConcurso!: SelectList[];
  listaComboInstituicao!: SelectList[];
  listaComboNacionalidade!: SelectList[];
  listaComboNaturalidade!: SelectList[];
  listaComboDeficiencia!: SelectList[];

  public desabilitarBtnSim : boolean=false;

  public displayStyle : string='';
  public textoMsgInscricao : string='';

  public retornoInscricao : any;

  public textoSpanDoc : string = '[Ver Menos]';
  public exibirDocs : boolean = true;

  public v_periodoAnoAC: string='';

  constructor(
    private route : ActivatedRoute,
    private router: Router,
    private repository: RepositoryService,
    private comboService: CombosService,
    private toastr: ToastrService,
    protected utilService: UtilService,
    public objBoletoApi : AcompanhamentoService,
    public objConfirmacaoService : ConfirmacaoInscricaoService,
    private filesaverservice : FileSaverService
  )
  {
    this.confirmacaoFichaInscricao = new FichaCadastro();
  }

  ngOnInit(): void {
    this.utilService.showLoading();

    this.confirmarFichaInscricaoForm = new FormGroup({
      DeAcordo: new FormControl(null, [Validators.required])
    });

    let objCipto : Criptografar = new Criptografar();
    debugger;
    this.confirmacaoFichaInscricao  = JSON.parse(objCipto.decrypt(this.route.snapshot.queryParams['session']));
    this.isExibeOpcaoCotista = this.confirmacaoFichaInscricao.cotista;

    this.listaRadioCotista = this.comboService.getCotista();
    this.listaComboCienciaConcurso = this.comboService.getCienciaConcurso();
    this.comboService.preencheCombos('deficiencia').subscribe((lista: any) => { this.listaComboDeficiencia = lista; });
    this.comboService.preencheCombos('pais').subscribe((lista: any) => { this.listaComboNacionalidade = lista; });
    this.comboService.preencheCombos('federacao', '1').subscribe((lista: any) => { this.listaComboNaturalidade = lista; });
    this.comboService.preencheCombos('instituicao').subscribe((lista: any) => { this.listaComboInstituicao = lista; });
    this.getperiodoAnoAC();
    this.utilService.showLoading(false);
  }

  getperiodoAnoAC(){
    this.objConfirmacaoService.getDescricaoConcursoAC("AC")
    .subscribe((retorno) => {
      this.v_periodoAnoAC=retorno;
    });
  }

  onSubmitForm(fichaInscricao: FichaCadastro) {

    if (this.confirmarFichaInscricaoForm.invalid &&
        this.confirmarFichaInscricaoForm.controls['DeAcordo'].value == false) {
      return;
    }

    this.utilService.showLoading();
    this.repository.create(`/Inscricao/GravarCandidato`, fichaInscricao).subscribe(
      (retorno) => {
        this.retornoInscricao=retorno;

        if(this.retornoInscricao.realizada === true){

          if(fichaInscricao.cotista){
            this.msgPopUp('Sua inscrição '+ this.retornoInscricao.codInscr +', como cotista, no Concurso de Seleção e Ingresso da EMERJ '+
            'foi realizada, MAS SÓ SERÁ VALIDADA COM O DEFERIMENTO DE TODOS OS DOCUMENTOS EXIGIDOS NA FORMA DO EDITAL. </br>'+
            'No caso de INDEFERIMENTO, o pagamento do boleto da inscrição deverá ser efetuado apenas se o candidato quiser ingressar no Concurso como ampla concorrência.','Aviso','SUCESS',true);
          }else{
            this.msgInscricaoAmpla('Sua inscrição foi realizada com sucesso, '+
                          'seu número de inscrição é <b>' + this.retornoInscricao.codInscr +
                          '</b></br>O boleto será gerado ao fechar essa mensagem.'+
                          '</br>Esse boleto só poderá ser pago no próximo dia útil.','Aviso');
          }

        }else{
          this.msgPopUp(this.retornoInscricao.msgErro,'Aviso','WARNING');
        }
        this.utilService.showLoading(false);
      },
      error => {
        this.utilService.showLoading(false);
        this.toastr.error(error);
      }
    );
  }

  redirecionarParaAcompanhamento(){
    let objCripto : Criptografar = new Criptografar();
    var objAcesso = new Acesso();
    debugger;

    objAcesso.cpf=this.retornoInscricao.cpf;
    objAcesso.inscricao=this.retornoInscricao.codInscr;
    objAcesso.candidatoInscrito=true;
    objAcesso.ind_prazoConcurso=this.confirmacaoFichaInscricao.ind_prazoConcurso;

    let strAcesso = objCripto.encrypt(JSON.stringify(objAcesso));
    this.router.navigate(['/acompanhamento'], {queryParams: { n: strAcesso }});
  }

  btnNao() {
    window.location.href="https://www.site.emerj.jus.br";
  }

  habilitaBtnSim() {
    return this.confirmarFichaInscricaoForm.invalid;
  }

  getDescricaoById(codigo: string, controlName: string): string | undefined {
    switch(controlName) {
      case 'cotista':
        return this.listaRadioCotista.find(cotista => cotista.codigo === codigo)?.descricao;
      case 'nacionalidade':
        return this.listaComboNacionalidade.find(nacionalidade => nacionalidade.codigo === codigo)?.descricao;
      case 'naturalidade':
        return this.listaComboNaturalidade.find(naturalidade => naturalidade.codigo === codigo)?.descricao;
      case 'concurso':
        return this.listaComboCienciaConcurso.find(concurso => concurso.codigo === codigo)?.descricao;
      case 'instituicao':
        return this.listaComboInstituicao.find(instituicao => instituicao.codigo === codigo)?.descricao;
      case 'deficiencia':
        return this.listaComboDeficiencia.find(deficiencia => deficiencia.codigo === codigo)?.descricao;
      default:
        return '';
    }
  }

  aceiteContrato(){
    if(this.confirmarFichaInscricaoForm.controls['DeAcordo'].value){
      this.desabilitarBtnSim=true;
    }else{
      this.desabilitarBtnSim=false;
    }
  }

  mostrarEsconderDoc(){
    if(this.exibirDocs==false){
      this.exibirDocs=true;
      this.textoSpanDoc='[Ver Menos]';
    }else if(this.exibirDocs==true){
      this.exibirDocs=false;
      this.textoSpanDoc='[Ver Mais]';
    }
  }

  msgInscricaoAmpla(texto: string,titulo :string){

    const options : Partial<IndividualConfig> ={
      'extendedTimeOut': 10000,
      'timeOut': 10000,
      'enableHtml': true,
      'tapToDismiss': false,
      'progressBar': true,
      'progressAnimation': 'increasing',
      'closeButton': true
    };

    const mToast=this.toastr.success(texto,titulo,options);

    mToast.onHidden.subscribe((close) => {
      this.imprimirBoletoBinario();
      this.redirecionarParaAcompanhamento();
    });

  }

  msgPopUp(texto: string,
           titulo :string,
           tipoToastr : string,
           redirecionarAcompanhamento : boolean = false){

    const options : Partial<IndividualConfig> ={
      'extendedTimeOut': 10000,
      'timeOut': 10000,
      'enableHtml': true,
      'tapToDismiss': false,
      'progressBar': true,
      'progressAnimation': 'increasing',
      'closeButton': true
    };

    if(tipoToastr == 'SUCESS'){
      this.toastr.success(texto,titulo,options );
    }else if(tipoToastr == 'INFO' ){
      this.toastr.info(texto,titulo, options);
    }else if(tipoToastr == 'ERROR' ){
      this.toastr.error(texto,titulo, options);
    }else if(tipoToastr == 'WARNING' ){
      this.toastr.warning(texto,titulo, options);
    }

    if(redirecionarAcompanhamento){
      this.redirecionarParaAcompanhamento();
    }

  }

  imprimirBoletoBinario(){
    this.utilService.showLoading();
    this.objBoletoApi.retornaBoletoBinario(this.retornoInscricao.cpf,
                                            this.retornoInscricao.codInscr)
    .subscribe(
      (res) => {
        const nameRel = 'boleto_' + this.retornoInscricao.codInscr;
        res.filename = nameRel + '.pdf';
        const byteCharacters = atob(res.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: `application/pdf` });
        this.filesaverservice.save(blob, res.filename);
        this.utilService.showLoading(false);
      },
      error => {
        this.utilService.showLoading(false);
        window.alert(error);
      }
    );
  }

  btnRetornarTelaAnterior() {
    let objCripto: Criptografar = new Criptografar();
    let strDocumentos = objCripto.encrypt(JSON.stringify(this.confirmacaoFichaInscricao));

    if(this.confirmacaoFichaInscricao.cotista === true){
        this.router.navigate(['/documentos'], { queryParams: { session: strDocumentos } });
    }
    else {
      this.router.navigate(['/fichainscricao'], { queryParams: { session: strDocumentos } });
    }
  }


}
